/*jshint esversion: 11 */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert,
  Input
} from 'reactstrap';
import Select from 'react-select';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { addNewBatch } from '../../api/batch';
import { getOfferingList } from '../../api/offering';
import { getStaffList } from '../../api/staff';
import { scheduleEnum } from '../Utility/Enumerator';
import FormUpload from '../../components/FormUpload';
import { viewSections } from '../../api/section';

const CreateBatchModal = ({
  modalOpenState,
  closeModalHandler,
  fetchNewBatchList,
  authUser
}) => {
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });
  const [images, setImages] = useState([]);
  const [offeringOptions, setOfferingOptions] = useState([]);
  const [offeringOptionsLoading, setOfferingOptionsLoading] = useState(false);
  const [selectedOffering, setSelectedOffering] = useState(null);
  const [totalFee, setTotalFee] = useState(0);
  const [sessFee, setSessionlFee] = useState(0);
  const [noOfSessions, setNumberOfSessions] = useState(1);
  const [staffOptions, setStaffOptions] = useState([]);
  const [staffOptionsLoading, setStaffOptionsLoading] = useState(false);
  const [selectedPrimaryTeacher, setSelectedPrimaryTeacher] = useState(null);
  const [sectionLoading, setSectionLoading] = useState(false);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [hasCron, setHasCron] = useState(false);

  const [sessionBatch, setSessionbatch] = useState({
    value: false,
    label: 'Normal Batch'
  });

  const [batchType] = useState([
    {
      value: false,
      label: 'Normal Batch'
    },
    {
      value: true,
      label: 'Session Batch'
    }
  ]);

  const [quarters, setQuarters] = useState([
    {
      month: '',
      base_fee: 0,
      penalty_day: 1,
      penalty_percentage: 0,
      alert_day: 5
    }
  ]);

  const [selectedSecondaryTeacher, setSelectedSecondaryTeacher] =
    useState(null);

  const scheduleOptions = scheduleEnum;
  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const [batchCreateRequestLoading, setBatchCreateRequestLoading] =
    useState(false);
  const [successAlert, setSuccessAlert] = useState({
    message: '',
    show_alert: false
  });

  async function handleBatchCreation(event, values) {
    resetErrorAlert();
    if (!selectedOffering) {
      showErrorAlert('Please select a offering');
      return;
    }
    if (!selectedSchedule) {
      showErrorAlert('Please select schedule');
      return;
    }

    let tempTotalFee = 0;
    quarters.map((q) => {
      tempTotalFee += Number(q.base_fee);
    });

    if (!selectedSchedule?.value && tempTotalFee !== Number(totalFee)) {
      showErrorAlert('Quarter Base fees must be equal to Batch total Fees');
      return;
    }

    let form = new FormData();
    form.set('name', values.name);
    form.set('offering', selectedOffering.value);
    form.set('start_date', values.start_date);
    form.set('end_date', values.end_date);
    form.set('start_time', values.start_time);
    form.set('end_time', values.end_time);
    form.set('schedule', selectedSchedule.value);
    form.set('summary', values.summary);
    form.set('sessionFee', parseInt(sessFee));
    form.set('totalFee', parseInt(totalFee));
    form.set('totalSessions', parseInt(noOfSessions));
    form.set('isSessionBatch', sessionBatch.value);
    form.set('hasCron', hasCron);

    if (!sessionBatch.value) {
      quarters.map((q) => {
        form.append('quarters', JSON.stringify(q));
      });
    }

    form.set('detail', values.detail);
    form.set('color', values.color);
    if (selectedPrimaryTeacher)
      form.set('primary_teacher', selectedPrimaryTeacher?.value);
    if (selectedSecondaryTeacher)
      form.set('secondary_teacher', selectedSecondaryTeacher?.value);
    if (images && images.length > 0) {
      images.map((g, index) => form.append(`pictures`, g));
    }
    if (attributes.length > 0) {
      attributes.forEach((attribute) => {
        form.append('attributes', attribute.value);
      });
    }
    setBatchCreateRequestLoading(true);
    const { response, error } = await addNewBatch(form);
    setBatchCreateRequestLoading(false);
    if (error) {
      showErrorAlert(error);
      return;
    }
    setSelectedPrimaryTeacher(null);
    setSelectedSecondaryTeacher(null);
    setSelectedOffering(null);
    setSelectedSchedule(null);
    setNumberOfSessions(1);
    setTotalFee(0);
    setSessionlFee(0);
    setQuarters([
      {
        month: '',
        base_fee: 0,
        penalty_day: 1,
        penalty_percentage: 0,
        alert_day: 5
      }
    ]);
    setHasCron(false);
    setSessionbatch({
      value: false,
      label: 'Normal Batch'
    });
    closeModalHandler();
    showSuccessAlert(response.message);
    fetchNewBatchList();
  }

  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  function showSuccessAlert(message) {
    setSuccessAlert({ message: message, show_alert: true });
  }

  function resetSuccessAlert() {
    setSuccessAlert({ message: '', show_alert: false });
  }

  function resetState() {
    resetSuccessAlert();
    resetErrorAlert();
  }

  function handleAddRemoveQuarters(action) {
    if (action === 'add') {
      const baseFee = sessFee / (quarters.length + 1);
      setSessionlFee(baseFee * (quarters.length + 1));
      setQuarters((prev) => {
        let tempQuarters = [...prev];
        tempQuarters = tempQuarters.map((q) => ({
          ...q,
          base_fee: baseFee
        }));
        tempQuarters.push({
          month: '',
          base_fee: baseFee,
          penalty_day: 1,
          penalty_percentage: 0,
          alert_day: 5
        });
        return tempQuarters;
      });
    } else if (action === 'remove') {
      if (quarters.length === 1) return;
      const baseFee = sessFee / (quarters.length - 1);
      setSessionlFee(baseFee * (quarters.length - 1));
      setQuarters((prev) => {
        let tempQuarters = [...prev];
        tempQuarters.pop();
        tempQuarters = tempQuarters.map((q) => ({
          ...q,
          base_fee: baseFee
        }));
        return tempQuarters;
      });
    }
  }

  function handleSessionFee(e) {
    const value = Number(e.target.value);
    setSessionlFee(value);
    setQuarters((prev) => {
      let updatedQuarters = [...prev];
      const perQuarterFee = value / quarters.length;
      updatedQuarters = updatedQuarters.map((q) => ({
        ...q,
        base_fee: perQuarterFee
      }));
      return updatedQuarters;
    });
    claculateTotalFee({ sessionFee: value });
  }

  function claculateTotalFee({
    sessionFee = sessFee,
    noOfSess = noOfSessions
  }) {
    let value = parseInt(sessionFee) * parseInt(noOfSess);
    setTotalFee(value);
  }

  function handleNoOfSessions(e) {
    setNumberOfSessions(e.target.value);
    claculateTotalFee({ noOfSess: e.target.value });
  }

  useEffect(() => {
    if (authUser) {
      fetchOfferingOptions();
      fetchStaffOptions();
      fetchSections();
    }
    // eslint-disable-next-line
  }, [authUser, modalOpenState]);

  const fetchOfferingOptions = async () => {
    setOfferingOptionsLoading(true);
    const response = await getOfferingList(1, 100);
    if (response) {
      setOfferingOptions(buildOptions(response?.data || []));
      setOfferingOptionsLoading(false);
    }
  };

  const fetchSections = async () => {
    setSectionLoading(true);
    const response = await viewSections(1, 10);
    if (response) {
      setSectionOptions(buildOptions(response?.data || []));
      setSectionLoading(false);
    }
  };

  const fetchStaffOptions = async () => {
    setStaffOptionsLoading(true);
    const response = await getStaffList(1, 100);
    if (response) {
      setStaffOptions(buildOptions(response?.data || []));
      setStaffOptionsLoading(false);
    }
  };

  function buildOptions(list) {
    return list.map((item) => ({
      value: item._id,
      label: item.name
    }));
  }

  function handleSelectSessionType(selectedItem) {
    setTotalFee(0);
    setNumberOfSessions(1);
    setSessionlFee(0);
    claculateTotalFee({ sessionFee: 0, noOfSess: 1 });
    setSessionbatch(selectedItem);
  }

  async function searchAttribute(e) {
    if (e.key.slice(0, 5) !== 'Arrow') {
      setSectionLoading(true);
      const response = await viewSections(1, 10, {
        filter_name: e.target.value
      });
      if (response) {
        setSectionOptions(buildOptions(response?.data || []));
        setSectionLoading(false);
      }
    }
  }

  return (
    <React.Fragment>
      {successAlert.show_alert && (
        <SweetAlert success title="Created" onConfirm={resetState}>
          {successAlert.message}
        </SweetAlert>
      )}
      <Modal isOpen={modalOpenState} backdrop="static" size="xl">
        <ModalHeader toggle={closeModalHandler}>Add New Batch</ModalHeader>
        <ModalBody>
          {requestError ? (
            <Alert
              color="danger"
              role="alert"
              isOpen={requestError.show_alert}
              toggle={resetErrorAlert}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {requestError.message}
            </Alert>
          ) : null}
          <AvForm
            className="needs-validation"
            onValidSubmit={handleBatchCreation}
          >
            <Row>
              {/* Name */}
              <Col md="6">
                <FormGroup>
                  <Label>Batch Name</Label>
                  <AvField
                    name="name"
                    placeholder="Enter Batch Name ..."
                    type="text"
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Batch name is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* Offering */}
              <Col md="6">
                <FormGroup>
                  <Label>Offering</Label>
                  <Select
                    options={offeringOptions}
                    disabled={offeringOptionsLoading}
                    onChange={(val) => setSelectedOffering(val)}
                    value={selectedOffering}
                  />
                </FormGroup>
              </Col>

              {/* Color */}
              <Col md="4">
                <FormGroup>
                  <Label>Color</Label>
                  <AvField
                    name="color"
                    placeholder="Enter Batch Color ..."
                    type="color"
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Batch Color is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* Start Date */}
              <Col md="4">
                <FormGroup>
                  <Label>Start Date</Label>
                  <AvField
                    name="start_date"
                    placeholder="Enter Start Date ..."
                    type="date"
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Start date is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* End Date */}
              <Col md="4">
                <FormGroup>
                  <Label>End Date</Label>
                  <AvField
                    name="end_date"
                    placeholder="Enter End Date ..."
                    type="date"
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'End date is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* Start Timing */}
              <Col md="4">
                <FormGroup>
                  <Label>Start Time</Label>
                  <AvField
                    name="start_time"
                    placeholder="Enter Start time ..."
                    type="time"
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Start time is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* End Timing */}
              <Col md="4">
                <FormGroup>
                  <Label>End Time</Label>
                  <AvField
                    name="end_time"
                    placeholder="Enter End Time ..."
                    type="time"
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'End time is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* Schedule */}
              <Col md="4">
                <FormGroup>
                  <Label>Schedule</Label>
                  <Select
                    options={scheduleOptions}
                    onChange={(val) => setSelectedSchedule(val)}
                    value={selectedSchedule}
                  />
                </FormGroup>
              </Col>

              {/* Primary Teacher */}
              <Col md="6">
                <FormGroup>
                  <Label>Primary Teacher</Label>
                  <Select
                    options={staffOptions}
                    disabled={staffOptionsLoading}
                    onChange={(val) => setSelectedPrimaryTeacher(val)}
                    value={selectedPrimaryTeacher}
                  />
                </FormGroup>
              </Col>

              {/* Secondary Teacher */}
              <Col md="6">
                <FormGroup>
                  <Label>Secondary Teacher</Label>
                  <Select
                    options={staffOptions}
                    disabled={staffOptionsLoading}
                    onChange={(val) => setSelectedSecondaryTeacher(val)}
                    value={selectedSecondaryTeacher}
                  />
                </FormGroup>
              </Col>

              {/* Batch Type */}
              <Col md="6">
                <FormGroup>
                  <Label>Batch Type</Label>
                  <Select
                    options={batchType}
                    onChange={handleSelectSessionType}
                    value={sessionBatch}
                  />
                </FormGroup>
              </Col>

              {/* Fee */}
              <Col md={sessionBatch?.value ? '2' : '4'}>
                <FormGroup>
                  <Label>
                    {sessionBatch?.value ? 'Session Fee' : 'Batch Fee'}
                  </Label>
                  <AvField
                    type="number"
                    name="fees"
                    value={sessFee}
                    onChange={(e) => handleSessionFee(e)}
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Batch fees is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* Add/Remove More Quarter */}
              {!sessionBatch?.value && (
                <Col md="2">
                  <Label>Add/Remove Quarters</Label>
                  <div className="d-flex align-items-center g-1">
                    <Button
                      color="primary"
                      onClick={() => handleAddRemoveQuarters('add')}
                    >
                      Add
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => handleAddRemoveQuarters('remove')}
                      style={{ marginLeft: '10px' }}
                      disabled={quarters.length === 1}
                    >
                      Remove
                    </Button>
                  </div>
                </Col>
              )}

              {/* No. of sessions */}
              {sessionBatch?.value ? (
                <Col md="2">
                  <FormGroup>
                    <Label>Number Of Sessions</Label>
                    <Input
                      type="number"
                      value={noOfSessions}
                      onChange={(e) => handleNoOfSessions(e)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
              ) : null}

              {/* Total Fee */}
              {sessionBatch.value && (
                <Col md="2">
                  <FormGroup>
                    <Label>Total Fee</Label>
                    <Input
                      type="number"
                      value={totalFee}
                      onChange={(e) => setTotalFee(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
              )}

              {/* QUARTER DATA */}
              {!sessionBatch.value &&
                quarters.map((quarter, index) => (
                  <>
                    <Col md="12"></Col>
                    {/* Quarter Month */}
                    <Col md="3">
                      <FormGroup>
                        <Label>Quarter {index + 1} Month</Label>
                        <AvField
                          name={`quarter${index}.month`}
                          placeholder="Month"
                          type="month"
                          value={quarter?.month}
                          className="form-control"
                          onChange={(e) => {
                            let updatedQuarters = [...quarters];
                            updatedQuarters[index].month = e.target.value;
                            setQuarters(updatedQuarters);
                          }}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: `Quarter ${
                                index + 1
                              } month is required`
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>

                    {/* Quarter base fee */}
                    <Col md="2">
                      <FormGroup>
                        <Label>Quarter {index + 1} Base Fee</Label>
                        <AvField
                          name={`quarter${index}.base_fee`}
                          placeholder="Base Fee"
                          type="Number"
                          className="form-control"
                          value={quarter?.base_fee}
                          onChange={(e) => {
                            let updatedQuarters = [...quarters];
                            updatedQuarters[index].base_fee = e.target.value;
                            setQuarters(updatedQuarters);
                          }}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: `Quarter ${
                                index + 1
                              } base fee is required`
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>
                    {/* Quarter Alert Day */}
                    <Col md="2">
                      <FormGroup>
                        <Label>Quarter {index + 1} Alert Day</Label>
                        <AvField
                          name={`quarter${index}.alert_day`}
                          placeholder="Alert sent before..."
                          type="Number"
                          className="form-control"
                          value={quarter?.alert_day}
                          onChange={(e) => {
                            let updatedQuarters = [...quarters];
                            updatedQuarters[index].alert_day = e.target.value;
                            setQuarters(updatedQuarters);
                          }}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: `Quarter ${
                                index + 1
                              } alert day is required`
                            },
                            min: {
                              value: 1,
                              errorMessage: 'Minimum alert day must be 1'
                            },
                            max: {
                              value: 29,
                              errorMessage: 'Maximum alert day must be 29'
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>

                    {/* Quarter Penalty day */}
                    <Col md="2">
                      <FormGroup>
                        <Label>Quarter {index + 1} Penalty Day</Label>
                        <AvField
                          name={`quarter${index}.penalty_day`}
                          placeholder="Penalty apllied after..."
                          type="Number"
                          className="form-control"
                          value={quarter?.penalty_day}
                          onChange={(e) => {
                            let updatedQuarters = [...quarters];
                            updatedQuarters[index].penalty_day = e.target.value;
                            setQuarters(updatedQuarters);
                          }}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: `Quarter ${
                                index + 1
                              } penalty day is required`
                            },
                            min: {
                              value: 1,
                              errorMessage: 'Minimum penalty day must be 1'
                            },
                            max: {
                              value: 29,
                              errorMessage: 'Maximum penalty day must be 29'
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>

                    {/* Quarter Penalty Percentage */}
                    <Col md="3">
                      <FormGroup>
                        <Label>Quarter {index + 1} Penalty Percentage</Label>
                        <AvField
                          name={`quarter${index}.penalty_percentage`}
                          placeholder="Enter Penalty percentage..."
                          type="Number"
                          className="form-control"
                          value={quarter?.penalty_percentage}
                          onChange={(e) => {
                            let updatedQuarters = [...quarters];
                            updatedQuarters[index].penalty_percentage =
                              e.target.value;
                            setQuarters(updatedQuarters);
                          }}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: `Quarter ${
                                index + 1
                              } penalty percentage is required`
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </>
                ))}

              {/* Attributes */}
              <Col md="12">
                <FormGroup>
                  <Label for="sections">Select attributes</Label>
                  <Select
                    // styles={styles}
                    disabled={sectionLoading}
                    options={sectionOptions}
                    isClearable={false}
                    isMulti
                    value={attributes}
                    onChange={(val) => setAttributes(val)}
                    onKeyDown={searchAttribute}
                  />
                  {/* </FormGroup> */}
                </FormGroup>
              </Col>

              {/* Summary */}
              <Col md="12">
                <FormGroup>
                  <Label>Summary</Label>
                  <AvField
                    name="summary"
                    placeholder="Enter Summary ..."
                    type="text"
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Summary is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* Details */}
              <Col md="12">
                <FormGroup>
                  <Label>Detail</Label>
                  <AvField
                    name="detail"
                    placeholder="Enter Detail ..."
                    type="textarea"
                    className="form-control"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: 'Detail is required'
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              {/* Images */}
               <Col md="12" className="mb-3">
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={hasCron}
                      onChange={(e) => setHasCron(e.target.checked)}
                    />{' '}
                    Enable Cron Job
                  </Label>
                </FormGroup>
              </Col>
              <Col md="12">
                <FormUpload title="Images" setImages={setImages} />
              </Col>
            </Row>

            <ModalFooter>
              <Button
                disabled={batchCreateRequestLoading}
                type="button"
                color="light"
                onClick={closeModalHandler}
              >
                Close
              </Button>
              <Button type="submit" color="success">
                {batchCreateRequestLoading ? 'Creating ...' : 'Add Batch'}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(CreateBatchModal);